/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VideosAnswerFull
 */
export interface VideosAnswerFull {
    /**
     * 
     * @type {number}
     * @memberof VideosAnswerFull
     */
    videoId?: number;
    /**
     * 
     * @type {string}
     * @memberof VideosAnswerFull
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof VideosAnswerFull
     */
    duration?: number;
    /**
     * 
     * @type {string}
     * @memberof VideosAnswerFull
     */
    program?: string;
    /**
     * 
     * @type {number}
     * @memberof VideosAnswerFull
     */
    videoOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof VideosAnswerFull
     */
    videoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof VideosAnswerFull
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof VideosAnswerFull
     */
    requiredTools?: string;
    /**
     * 
     * @type {string}
     * @memberof VideosAnswerFull
     */
    optionalTools?: string;
}

export function VideosAnswerFullFromJSON(json: any): VideosAnswerFull {
    return VideosAnswerFullFromJSONTyped(json, false);
}

export function VideosAnswerFullFromJSONTyped(json: any, ignoreDiscriminator: boolean): VideosAnswerFull {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'videoId': !exists(json, 'video-id') ? undefined : json['video-id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'program': !exists(json, 'program') ? undefined : json['program'],
        'videoOrder': !exists(json, 'video-order') ? undefined : json['video-order'],
        'videoUrl': !exists(json, 'video-url') ? undefined : json['video-url'],
        'thumbnailUrl': !exists(json, 'thumbnail-url') ? undefined : json['thumbnail-url'],
        'requiredTools': !exists(json, 'required-tools') ? undefined : json['required-tools'],
        'optionalTools': !exists(json, 'optional-tools') ? undefined : json['optional-tools'],
    };
}

export function VideosAnswerFullToJSON(value?: VideosAnswerFull | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'video-id': value.videoId,
        'title': value.title,
        'duration': value.duration,
        'program': value.program,
        'video-order': value.videoOrder,
        'video-url': value.videoUrl,
        'thumbnail-url': value.thumbnailUrl,
        'required-tools': value.requiredTools,
        'optional-tools': value.optionalTools,
    };
}


